import { MatPaginatorIntl } from '@angular/material/paginator';

const rangeLabel = (page: number, pageSize: number, length: number) => {
  const toLabel = `af`;

  if (length === 0 || pageSize === 0) {
    return `0 ` + toLabel + ` ${length}`;
  }

  length = Math.max(length, 0);

  const startIndex = page * pageSize;

  // If the start index exceeds the list length, do not try and fix the end index to the end.
  const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

  return `${startIndex + 1} - ${endIndex} ` + toLabel + ` ${length}`;
};

const rangeLabelNoTotal = (page: number, pageSize: number, length: number) => {
  length = Math.max(length, 0);

  const startIndex = page * pageSize;

  // If the start index exceeds the list length, do not try and fix the end index to the end.
  const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

  return `${startIndex + 1} - ${endIndex}`;
};

const itemsPerPageLabel = `Elementer pr side:`;
const nextPageLabel = `Næste side`;
const previousPageLabel = `Forrige side`;

export function getPaginatorIntl() {
  const paginatorIntl = new MatPaginatorIntl();

  paginatorIntl.itemsPerPageLabel = itemsPerPageLabel;
  paginatorIntl.nextPageLabel = nextPageLabel;
  paginatorIntl.previousPageLabel = previousPageLabel;
  paginatorIntl.getRangeLabel = rangeLabel;

  return paginatorIntl;
}

export function getPaginatorIntlNoTotal() {
  const paginatorIntl = new MatPaginatorIntl();

  paginatorIntl.itemsPerPageLabel = itemsPerPageLabel;
  paginatorIntl.nextPageLabel = nextPageLabel;
  paginatorIntl.previousPageLabel = previousPageLabel;
  paginatorIntl.getRangeLabel = rangeLabelNoTotal;

  return paginatorIntl;
}
